"use client"
import { getHolidayId, patchHoliday, postHoliday } from "@/actions";
import { BodyPostForm, ResponseGetHoliday } from "@/actions/holiday/interfaceHoliday";
import { ButtonModuleGlobal, FormButton, InputDate } from "@/components"
import { ModalComponent } from "@/components/ui/modal/ModalComponent";
import { TextField } from "@mui/material";
import dayjs from "dayjs";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import Swal from "sweetalert2";

interface Props {
    type: string,
    yearId?: string,
    id?: number
}

export const FormCalendar = ({ type, yearId, id }: Props) => {
    const router = useRouter()
    let [isOpen, setIsOpen] = useState(false)

    const { register,  formState: { isSubmitting }, control, handleSubmit, reset, watch } = useForm<BodyPostForm>({
        //resolver: yupResolver(validationSchema)FormYear
    });

    const [dataHoliday, setDataHolidy] = useState<ResponseGetHoliday>()

    function openModal() {
        if (type === "edit" && id) {
            getHolidayId(id).then((res) => setDataHolidy(res))
        } else {
            reset((res) => {
                return {
                    description: '',
                    date: new Date(),
                };
            });
        }
        setIsOpen(true)
    }
    
    const onSubmit: SubmitHandler<BodyPostForm> = async (data: BodyPostForm) => {
        const action = type !== "edit" ? postHoliday : patchHoliday;

        const bodyHoliday = {
            description: data.description,
            date: dayjs(data.date).format('YYYY-MM-DD'),
            yearId: Number(yearId)
        }
        action(bodyHoliday, id).then(res => {
            if(res.error){
                Swal.fire({
                    title: "Error",
                    text: "Error al crear dia festivo",
                    icon: "error"
                });
            }else{
                Swal.fire({
                    title: "Operacion Exitosa",
                    text: "Dia festivo creado exitosamente",
                    icon: "success"
                });
                router.refresh()
                setIsOpen(false)
            }
        })
    }

    useEffect(() => {
        if (dataHoliday) {
            reset({
                description: dataHoliday.description,
                date: dataHoliday.date
            })
        }
    }, [dataHoliday, reset]);
   

    return (
        <>
            <ButtonModuleGlobal openModal={openModal} type={type} />
            <ModalComponent setIsOpen={setIsOpen} isOpen={isOpen}>
                <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
                    <h2 className="text-center font-bold text-xl my-3">Nuevo Dia Festivo</h2>
                    <Controller
                        name="description"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <TextField onChange={onChange} id="outlined-basic" value={value || ""} label="Description" type="text" className="w-full" variant="outlined" />
                        )}
                    />

                    <Controller
                        control={control}
                        name="date"
                        rules={{ required: true }}
                        render={({ field: { value, onChange, ref } }) => (
                            <InputDate label="Fecha" value={value} onChange={onChange} />
                        )}
                    />
                     <FormButton isSubmitting={isSubmitting} />
                </form>
            </ModalComponent>
        </>
    )
}